<!--
<div class="modal modal-content modal-lg csc-modal-lg">
  <div class="modal-header">
    <h5 class="title">{{data.block.name}} History</h5>
  </div>

  <div class="modal-body">
    <p class="subtitle">{{'Click the date below to download your customized resources (in PDF format).' | translate}}</p>
  </div>



  <div class="modal-footer">
    <div class="item" *ngFor="let row of data.history; let i = index">
      <button class="btn btn-csc-primary" (click)="requestHistory(row.url, row.name, i)">
        {{row.name}}
        <i class="fa fa-spinner" aria-hidden="true" [hidden]="!isLoading(i)"></i>
      </button>
    </div>
    <button class="btn btn-csc-primary" [mat-dialog-close]="true">{{'Close' | translate}}</button>
  </div>

</div>-->



  <div class="modal-content csc-modal">
    <div class="modal-header">
      <h5 class="title">{{data.block.name}} History</h5>
    </div>
    <div class="modal-body">
      <p class="subtitle">{{'Click the date below to download your customized resources (in PDF format).' | translate}}</p>
    </div>
    <div class="modal-footer">
      <div class="col-sm-12">
        <div class="col-sm-2">
          <button class="btn btn-secondary" [mat-dialog-close]="true">{{'Close' | translate}}</button>    </div>

      </div>
        <div class="div-button-section">
          <div class="col-sm-2">
            <div class="item" *ngFor="let row of data.history; let i = index">
              <button class="btn btn-csc-primary" (click)="requestHistory(row.url, row.name, i)">
                {{row.name}}
                <i class="fa fa-spinner" aria-hidden="true" [hidden]="!isLoading(i)"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

  </div>
